import React from "react";

export function CustomerQuote(props) {
    return (
        <div
            className={`flex flex-col w-full justify-start items-center lg:flex-row lg:items-start ${
                props.className ? props.className : ""
            }`}
        >
            <img
                className="w-40 h-40 mb-8 lg:mr-8 lg:mb-0"
                src={props.img}
            />
            <div className="text-[1.4rem]">
                <div className="mb-4">
                    <i>"{props.quote}"</i>
                </div>
                {props.customer}
            </div>
        </div>
    );
}
